import { call, put, takeEvery,takeLatest,delay } from 'redux-saga/effects';
import { AuthenticationHelper} from '../../../../utils/API/BackendHelper/auth';
import * as actions from './_actions';
import * as types from './_actionTypes';

// Test credentials for all roles


function* loginSaga(action) {
  try {
    const { username, password } = action.payload;
    

  const result = yield call(AuthenticationHelper.login, { identifier: username, password });

  if (result.success) {
    const { user}  = result.data;

  yield put(actions.loginSuccess( user ));

  const profileResponse = yield call(AuthenticationHelper.getProfile);
  if (profileResponse.success && profileResponse.data) {
    yield put(actions.checkAuthSuccess(profileResponse.data));
  }

  } else {
    throw new Error(result.message || 'Invalid credentials');
  }
  } catch (error) {
    const errorMessage = error.message || 'Login failed';
    yield put(actions.loginFailure(errorMessage));
  }
}


// checkAuthSaga - minimal and loop-safe
function* checkAuthSaga() {
  try {
    yield put(actions.checkAuthStart());
    const profileResponse = yield call(AuthenticationHelper.getProfile);
    if (profileResponse.success && profileResponse.data) {
      yield put(actions.checkAuthSuccess(profileResponse.data));
    } else {
      yield put(actions.checkAuthFailure('Profile fetch failed'));
    }
  } catch (e) {
    yield put(actions.checkAuthFailure(e.message || 'Auth check failed'));
  } finally {
    yield put(actions.setInitialCheckDone());
  }
}





function* logoutSaga() {
  try {
    console.log('🔓 LOGOUT saga started');


    yield call(AuthenticationHelper.logout);
    console.log('✅ Server logout successful');


    yield put(actions.logoutSuccess());
    console.log('✅ Client logout successful');
 yield call([window.location, 'assign'], '/auth/login');
  

  } catch (error) {
    console.error('❌ Logout error:', error);
    
   
    console.warn('⚠️ Server logout failed, clearing client state anyway');
    yield put(actions.logoutSuccess());
    

  }
}


function getRoleBasedRedirect(role) {
  const normalizedRole = role?.toLowerCase(); // ✅ Make case-insensitive
  
  switch (normalizedRole) {
    case 'admin':
      return '/admin/dashboard';
    case 'student':
      return '/student/courses/available_courses';
    case 'sme':
      return '/sme/dashboard';
    case 'college':
      return '/college/dashboard';
    default:
      return '/auth/login';
  }
}
function* authSaga() {
  yield takeEvery(types.LOGIN_REQUEST, loginSaga);
   yield takeLatest(types.CHECK_AUTH, checkAuthSaga);
  yield takeEvery(types.LOGOUT_REQUEST, logoutSaga);
}

export default authSaga;